import { Injectable } from '@angular/core';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { DeviceService, DevicesService } from '@era/osupdates-sdk';
import { Store } from '@ngrx/store';
import { DevicesRouterStoreSelectors } from '../../../../stores/router';
import {
  DevicesOsUpdateStatesResolverActions,
  DeviceOsUpdateStatesResolverActions,
  SignalRActions,
  DevicesApiActions,
  DeviceApiActions,
} from './devices-os-update-status.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class DevicesOsUpdateStatesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly devicesService: DevicesService,
    private readonly deviceService: DeviceService,
    private readonly routerStore: Store<Router>
  ) {}

  osUpdateStatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DevicesOsUpdateStatesResolverActions.osUpdateStatesRequested),
      mergeMap(({ locationId }) =>
        safeMap(
          this.devicesService.getOsUpdateStates(locationId),
          (states) =>
            DevicesApiActions.osUpdateStatesLoaded({
              osUpdateStatuses: states.map((state) => ({
                locationId: locationId,
                udid: state.udid,
                overviewState: state.state,
              })),
            }),
          (error) => DevicesApiActions.osUpdateStatesLoadedError({ error })
        )
      )
    );
  });

  osUpdateStateRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DeviceOsUpdateStatesResolverActions.osUpdateStateRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceService.getOsUpdateState(udid),
          (x) => DeviceApiActions.osUpdateStateLoaded({ osUpdateStatus: x }),
          (error) => DeviceApiActions.osUpdateStateLoadedError({ error })
        )
      )
    );
  });

  osUpdateSignalRUpdateEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(SignalRActions.receivedOsUpdateStatusCommand),
      withLatestFrom(this.routerStore.select(DevicesRouterStoreSelectors.selectUdid)),
      filter(([{ commandProgress }, currentDevice]) => commandProgress.udid === currentDevice),
      mergeMap(([{ commandProgress }]) =>
        safeMap(
          this.deviceService.getOsUpdateState(commandProgress.udid),
          (x) => DeviceApiActions.osUpdateStateLoaded({ osUpdateStatus: x }),
          (error) => DeviceApiActions.osUpdateStateLoadedError({ error })
        )
      )
    );
  });
}
